/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-donnes-du-dossier': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M18 17.54l-.45-1.8a2.61 2.61 0 00-1.72-1.85l-3.3-1.1c-.81-.34-1.17-1.63-1.25-2.12a3.15 3.15 0 001.11-2c0-.26.07-.37.09-.38a.36.36 0 00.24-.29 5.53 5.53 0 00.41-1.64.29.29 0 000-.09.94.94 0 00-.36-.54v-2a2.19 2.19 0 00-.76-2C11.92 1.19 11.3 0 9 0a3.91 3.91 0 00-3.75 3.76v2a.94.94 0 00-.36.54.28.28 0 000 .09A5.61 5.61 0 005.28 8a.31.31 0 00.22.22s.13.13.13.39a3.13 3.13 0 001.1 2c-.08.49-.44 1.78-1.22 2.11l-3.33 1.17a2.61 2.61 0 00-1.72 1.85L0 17.54a.39.39 0 00.07.33.37.37 0 00.3.14h17.26a.37.37 0 00.29-.14.39.39 0 00.08-.33z"/>'
  }
})
